"use strict";
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var classnames_1 = __importDefault(require("classnames"));
var react_1 = __importDefault(require("react"));
var react_hook_form_1 = require("react-hook-form");
var react_query_1 = require("react-query");
var api_1 = require("../../../api");
var callout_1 = require("../../../components/callout");
var error_message_1 = __importDefault(require("../../../components/error_message"));
var loading_modal_1 = __importDefault(require("../../../components/loading_modal"));
var save_button_1 = require("../../../components/save_button");
var update_subscription_1 = require("../../../mutations/update-subscription");
var get_subscription_frequencies_1 = require("../../../queries/get-subscription-frequencies");
exports.default = (function (_a) {
    var subscription = _a.subscription, bundleType = _a.bundleType, openDrawer = _a.openDrawer, setOpenDrawer = _a.setOpenDrawer;
    var _b = (0, react_hook_form_1.useForm)({
        mode: 'all',
        defaultValues: {
            frequency: subscription.order_interval_frequency,
        },
    }), register = _b.register, handleSubmit = _b.handleSubmit, errors = _b.errors;
    var queryKey = 'getSubscriptionFrequencies';
    // get/generate a unique queryKey for each type of bundle so that we don't get the wrong cached frequency value
    var getQueryKey = function () {
        switch (bundleType) {
            case 'Vitamin':
                return queryKey + 'Vitamins';
            case 'Training Pant':
                return queryKey + 'TrainingPants';
            case 'Diaper':
                return queryKey + 'Diaper';
            default:
                return queryKey;
        }
    };
    var frequenciesData = (0, react_query_1.useQuery)(getQueryKey(), function () {
        return (0, api_1.getSubscriptionAPIClient)().request(get_subscription_frequencies_1.GetSubscriptionFrequencies, { subscriptionId: subscription.id });
    }).data;
    var frequencies = frequenciesData === null || frequenciesData === void 0 ? void 0 : frequenciesData.getSubscriptionFrequencies.frequencies;
    var unit = frequenciesData === null || frequenciesData === void 0 ? void 0 : frequenciesData.getSubscriptionFrequencies.unit;
    // show more frequency options for vitamin bundles
    // diaper and fundamentals bundles might have 3+ options when being created, but we don't want to present ALL of them when editing
    var frequencyOptions = bundleType === 'Vitamin' ? frequencies : frequencies === null || frequencies === void 0 ? void 0 : frequencies.slice(0, 3);
    var queryClient = (0, react_query_1.useQueryClient)();
    var callout = (0, callout_1.useCallout)().callout;
    var onFrequencySubmit = handleSubmit(function (data) { return __awaiter(void 0, void 0, void 0, function () {
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0: return [4 /*yield*/, mutateSubscription({
                        updates: {
                            charge_interval_frequency: data.frequency.toString(),
                            order_interval_frequency: data.frequency.toString(),
                            order_interval_unit: subscription.order_interval_unit,
                        },
                        subscriptionId: subscription.id,
                    })];
                case 1:
                    _a.sent();
                    return [2 /*return*/];
            }
        });
    }); });
    var _c = (0, react_query_1.useMutation)('updateFrequency', function (variables) { return (0, api_1.getSubscriptionAPIClient)().request(update_subscription_1.UPDATE_SUBSCRIPTION, variables); }, {
        onSuccess: function () {
            queryClient.invalidateQueries('getCustomerSubscriptions');
            callout.success('Successfully Updated Frequency!');
        },
    }), mutateSubscription = _c.mutateAsync, isUpdatingSubscription = _c.isLoading, isError = _c.isError, error = _c.error;
    return (react_1.default.createElement(react_1.default.Fragment, null,
        react_1.default.createElement(loading_modal_1.default, { isLoading: isUpdatingSubscription, error: isError }),
        react_1.default.createElement("a", { onClick: function () { return setOpenDrawer(openDrawer === 'frequency' ? undefined : 'frequency'); } },
            react_1.default.createElement("div", { className: 'account-subheader' },
                "Frequency",
                react_1.default.createElement("span", { className: "arrow ".concat(openDrawer === 'frequency' ? 'up' : 'down') })),
            react_1.default.createElement("div", null,
                react_1.default.createElement("p", null,
                    "Every ",
                    subscription.order_interval_frequency,
                    " ",
                    subscription.order_interval_unit,
                    "s"))),
        react_1.default.createElement("div", { className: (0, classnames_1.default)('account-drawer-content', { open: openDrawer === 'frequency' }) },
            react_1.default.createElement("div", { className: (0, classnames_1.default)('grid-x padding-vertical-3') }, frequencyOptions &&
                frequencyOptions.map(function (option) { return (react_1.default.createElement("div", { className: 'small-4 padding-horizontal-1 padding-bottom-1', key: option },
                    react_1.default.createElement("div", { className: 'account-radio-toolbar', key: option },
                        react_1.default.createElement("input", { defaultChecked: option === Number(subscription.order_interval_frequency), type: 'radio', value: option, id: 'radio' + option, name: 'frequency', ref: register({ required: true }) }),
                        react_1.default.createElement("label", { className: 'enabled', htmlFor: 'radio' + option },
                            option,
                            " ",
                            unit)),
                    react_1.default.createElement(error_message_1.default, { error: errors.frequency }))); })),
            react_1.default.createElement(save_button_1.SaveButton, { onClick: onFrequencySubmit, isLoading: isUpdatingSubscription })),
        isError && react_1.default.createElement(error_message_1.default, { error: { message: error } })));
});
